export default {
  'InvoicePage.backToBooking': {
    en: 'Back to bookings',
    fr: 'Retour au tableau de bord',
  },
  'InvoicePage.download': { en: 'Download', fr: 'Télécharger' },
};
